export default __webpack_public_path__ + "static/media/5.2dc4ec68.png";